export default function ZoomEvent(type, _a) {
    var sourceEvent = _a.sourceEvent, target = _a.target, transform = _a.transform, dispatch = _a.dispatch;
    Object.defineProperties(this, {
        type: { value: type, enumerable: true, configurable: true },
        sourceEvent: { value: sourceEvent, enumerable: true, configurable: true },
        target: { value: target, enumerable: true, configurable: true },
        transform: { value: transform, enumerable: true, configurable: true },
        _: { value: dispatch }
    });
}
